import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
	let userType = sessionStorage.getItem("userType")
	let token
	if(userType){
		token = sessionStorage.getItem("token");
	}else{
		 token = localStorage.getItem("token");
	}

	if (!token) {
		return <Navigate to="/" replace />;
	}

	return children;
};

export default ProtectedRoute;
